import { topics } from "@/mocks/guagua";
import SectionHeading from "./SectionHeading";

function Topics() {
  return (
    <section id="topic" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="深度专题"
          title="把热点看得更透"
          desc="不止于围观热闹，更带你走进瓜点背后的门道。编辑部深度观察，把事件脉络、行业逻辑一次讲清。"
          linkHref="#faq"
          linkLabel="浏览常见问题"
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {topics.map((topic) => (
            <article
              key={topic.title}
              className="group flex flex-col sm:flex-row overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="relative h-44 sm:h-auto sm:w-48 md:w-56 shrink-0 overflow-hidden">
                <img
                  src={topic.image}
                  alt={`${topic.title} 深度专题配图`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-2 top-2 rounded bg-accent-500 px-2 py-0.5 text-xs text-background-50">
                  {topic.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col justify-between gap-3 p-4 md:p-5">
                <div>
                  <h3 className="line-clamp-2 text-base md:text-lg font-medium text-foreground-900 transition-colors group-hover:text-primary-700">
                    {topic.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm text-foreground-600">
                    {topic.excerpt}
                  </p>
                </div>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-time-line" aria-hidden="true"></i>
                    {topic.readTime} 阅读
                  </span>
                  <span className="inline-flex items-center gap-1 text-primary-700">
                    阅读专题
                    <i
                      className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                      aria-hidden="true"
                    ></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Topics;